import { render, staticRenderFns } from "./RedHeadBox.vue?vue&type=template&id=938e76de&scoped=true"
import script from "./RedHeadBox.vue?vue&type=script&lang=js"
export * from "./RedHeadBox.vue?vue&type=script&lang=js"
import style0 from "./RedHeadBox.vue?vue&type=style&index=0&id=938e76de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "938e76de",
  null
  
)

export default component.exports